// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2jWPW","container":"styles_container__BTzQ6","title":"styles_title__3Q1af","wrapper":"styles_wrapper__1trfj","answer":"styles_answer__lVLqo"};